import styled from "styled-components/macro";
import { mediaQueries } from "../../styles/media";

export const QuotedPriceWrapper = styled.div`
  background: var(--juno-color-green);
  padding: 1em 1.25em;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 1em;
  ${mediaQueries.md} {
    margin-top: 0;
    margin-left: -31px;
    margin-right: -31px;
    padding-bottom: 0.5em;
    padding-left: 31px;
  }
  p {
    margin-top: 0;
    color: var(--juno-color-white);
  }
  a,
  a:link,
  a:visited {
    color: var(--juno-color-white);
    text-decoration: none;
    border-bottom: 1px solid;
  }
`;

export const QuotedPrice = styled.h2`
  color: var(--juno-color-white);
  font-weight: var(--juno-font-weight-bold);
  margin: 0.5em 0 0.25em 0;

  font-size: var(--juno-font-size-large-number-sm);
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-large-number-md);
    margin-bottom: 0.4em;
  }
`;

export const ListItemSuffix = styled.span`
  display: block;
  font-weight: var(--juno-font-weight-regular);
  font-family: var(--juno-font-family-mono);
  ${mediaQueries.sm} {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const QuoteBreakdown = styled.div`
  overflow: hidden;
  li {
    color: var(--juno-color-text-secondary);
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  button {
    margin-right: 0.75em;
    ${mediaQueries.sm} {
      margin-right: 1em;
    }
  }
`;
